import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=0c269f73&scoped=true&"
import script from "./Contracts.vue?vue&type=script&lang=ts&"
export * from "./Contracts.vue?vue&type=script&lang=ts&"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=0c269f73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c269f73",
  null
  
)

export default component.exports